// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  kind: __t.string(),
  contentRef: __t.string(),
  permCopy: __t.bool(),
  permModify: __t.bool(),
  permTransfer: __t.bool(),
  permRemix: __t.bool(),
  permTemplate: __t.bool(),
  isPremium: __t.bool(),
  polyCount: __t.u64(),
  textureBytes: __t.u64(),
};
